import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfigurationManagementService } from 'src/service/configuration-management.service';
import { LanguageManagementService } from 'src/service/language-management.service';
import { InteractionType, KeyValues5, LocalService, PageKey, PaymentGatewayServiceType, RelationShipRole, Status } from 'src/service/local.service';
import { QrPaymentService } from 'src/service/qr-payment.service';

@Component({
  selector: 'app-payment-gateways-config',
  templateUrl: './payment-gateways-config.component.html',
  styleUrl: './payment-gateways-config.component.scss'
})
export class PaymentGatewaysConfigComponent {
  lstSectionConfigKeys: string[] = ["qr_payment", "payment_gateway_cust_config"];
  ctryCode: string = ''; businessId: string = ''; userId: string = ''; interactionType = 0;
  isTermsAccepted: boolean | undefined = undefined; RelationShipRole = RelationShipRole;
  items: KeyValues5[] = []; itemsConfigured: KeyValues5[] = []; itemsUnconfigured: KeyValues5[] = [];

  constructor(public localService: LocalService, private route: ActivatedRoute, private configurationManagementService: ConfigurationManagementService, private languageManagementService: LanguageManagementService, private qrPaymentService: QrPaymentService, private router: Router) {

  }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.isTermsAccepted = undefined;
      this.interactionType = routeParams.interactionType;
      this.businessId = routeParams.businessId;
      this.userId = routeParams.userId;
      this.configurationManagementService.ensurePageActions(PageKey.PaymentGatewaysConfig, this.businessId);
      if (this.interactionType != InteractionType.User && (!this.businessId || this.businessId.length < 5)) {
        this.localService.redirectToSeller();
      } else {
        this.localService.saveUrl();
        this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType, routeParams.businessId);
        this.ctryCode = routeParams.ctryCode;
        this.onInitiate();
        this.onLoad();
      }
    });
  }

  onInitiate() {

  }

  onLoad() {
    if (this.localService.isUserHasBusinessRole(this.businessId, RelationShipRole.Admin)) {
      this.qrPaymentService.getConfiguredPaymentGateways(this.localService.getLoginAsCountryCode() , this.businessId).subscribe(result => {
        this.items = result;
        this.itemsConfigured = this.items.filter(x => x.v2 == '1');
        this.itemsUnconfigured = this.items.filter(x => x.v2 == '0');
        if (this.isTermsAccepted == undefined) {
          this.isTermsAccepted = this.itemsConfigured.length > 0;
        }
      });
    }
  }

  onAction(index: number, key: string = '') {
    switch (index) {
      case 1: {
        this.isTermsAccepted = true;
      } break;
      case 2: {
        switch (parseInt(key)) {
          case PaymentGatewayServiceType.RazorPay: {
            this.router.navigate(['/payment-gateway-customer' + this.localService.basicParamsString, this.businessId]);
          } break;
          default: {
            this.router.navigate(['/payment-gateway-config' + this.localService.basicParamsString, this.businessId, key]);
          } break;
        }
      } break;
      case 3: {
        this.qrPaymentService.updateBusinessPrimaryPaymentGateway(this.localService.getLoginAsCountryCode() , this.businessId, parseInt(key)).subscribe(result => {
          if (result.status == Status.Success) {
            this.items.forEach(itemTemp => {
              itemTemp.v3 = itemTemp.key == key ? '1' : '0';
            });
          }
        });
      } break;
    }
  }
}
